import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { customerActions } from "stores/customer/customerActions";
import { jarvsiOnestockOnboardingActions } from "stores/jarvisOnestock/jarvisOnestockOnboarding/jarvisOnestockOnboardingAction";
import { jarvisPrimeOnboardingActions } from "stores/jarvisPrime/jarvisPrimeOnboarding/jarvisPrimeOnboardingActions";
import { jarvsiRMSOnboardingActions } from "stores/jarvisRMS/jarvisRMSOnboarding/jarvisRMSOnboardingAction";
import { onboardingActions } from "stores/onboarding/onboardingActions";
import { PHCOnboardingActions } from "stores/PHC/PHCOnboarding/PHCOnboardingAction";
import { sentimentTrackerOnboardingActions } from "stores/SentimentTracker/sentimentTrackerOnboarding/sentimentTrackerOnboardingAction";

const mapStateToProps = (state) => {
  return {
    deviceId: state.common.deviceId,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      logoutAction: customerActions.logout,
      updateAuthDataAction: customerActions.updateAuthData,

      // update onboarding details of the product
      updateOnboardingDataAction: onboardingActions.updateOnboardingData,
      updateRMSOnboardingDataAction: jarvsiRMSOnboardingActions.updateRMSOnboardingData,
      updateOnestockOnboardingDataAction: jarvsiOnestockOnboardingActions.updateOnestockOnboardingData,
      updatePrimeOnboardingDataAction: jarvisPrimeOnboardingActions.updatePrimeOnboardingData,
      setSsoCustomerDetails : customerActions.ssoCustomerDetails,
      isSsoCustomer: customerActions.isSsoCustomerFlag,
      updateSentimentTrackerOnboardingDataAction: sentimentTrackerOnboardingActions.updateSentimentTrackerOnboardingData,  
      updatePHCOnboardingDataAction: PHCOnboardingActions.updatePHCOnboardingData,     
    },
    dispatch
  );

const LoginStore = (Container) =>
  connect(mapStateToProps, mapDispatchToProps)(Container);
export default LoginStore;
